import { uploadGuildFile } from 'app/frontend/base/api/guild'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { customDomainGuildHeaderTitleTypes } from 'app/frontend/types/custom/CustomDomainHeaderConfig'
import { CustomDomainSettingsSection } from 'app/frontend/base/pages/TeamDashboard/subpages/TeamSettings/components/sections/CustomDomainSection'

const CustomDomainSection = () => {
  const { guild } = useGuild()

  if (!guild) return null

  return (
    <CustomDomainSettingsSection
      entityType='guild'
      entity={guild}
      guild={guild}
      ownerLabel='guild'
      premiumPath={`${guild.path}/settings#premium`}
      titleTypeOptions={customDomainGuildHeaderTitleTypes}
      subtitleTypeOptions={customDomainGuildHeaderTitleTypes}
      subtitlePlaceholder='Nothing'
      uploadOwnerFile={async (file) =>
        (await uploadGuildFile(guild.id, file)).url
      }
    />
  )
}

export default CustomDomainSection
